import React from 'react';
import anime from 'animejs/lib/anime.es.js';
import { getPost } from '../funcs/posts';
import { ipremium } from '../funcs/premium';
import PremiumLogin from './premium';
import {Helmet} from "react-helmet";

var httpBuildQuery = require('http-build-query');
export default class Single extends React.Component{
  state = {
    post: false,
    isok: true
  }

  componentDidMount(){
    this.get();
    document.body.classList.add('single');
  }

  componentDidUpdate(op){
    if(this.props.slug !== op.slug){
      this.get();
    }
  }


  get(){
    /* Premium */
    var slug = this.props.match.params.slug;
    var post = getPost(slug);

    var pd = post.premiumUntil;
    var isok = ipremium(pd);
    this.setState({
      post: post,
      isok: isok
    })
    window.scroll(0, 0);
  }

  render(){
    if(!this.state.post){
      return null;
    }
    var p = this.state.post;
    var bg = "linear-gradient(to bottom, "+ p.bg.join(',') +")"
    return(
      <>
      {
        this.state.isok ?
        <div id="single" className="page fullpage" style={{background: bg}}>
          <Helmet>
            <title>#JusticiaCotidiana: {p.title}</title>
          </Helmet>
          <div id="single_container">
            {
              !p.isHighlightedVideo ?
              <div id="single_container_img"><img src={p.image} /></div>
              :
              <div id="single_container_img" className="single_container_imgvideo">
                <iframe width="560" height="315" src={p.video} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            }
            <div id="single_container_content">
              <h1 id="single_container_content_title">{p.title}</h1>
              <a style={{marginTop: '1rem', textTransform: 'uppercase', fontSize: '0.9rem', fontWeight: 600, display: 'inline-block', padding:'0.35rem 0.5rem', backgroundColor: '#f00143', color: 'white', marginBottom: '1rem'}} href={"https://www.animalpolitico.com/everyday-justice-mexico/" + p.tslug}>
                English version
              </a>
              <div id="single_container_content_meta" style={{borderColor: p.bg[0]}}>
                <div className="sccm_r" id="single_container_content_meta_date">{p.date}</div>
              </div>
              <SingleSharers p={p} />
              <div id="single_container_content_text">
                {p.content}
              </div>
              <SingleSharers p={p} />
            </div>
          </div>
        </div>
        :
        <PremiumLogin />
      }
      </>
    )
  }
}

export class SingleSharers extends React.Component{
  render(){

    /* Twitter */
    var u = 'https://twitter.com/intent/tweet';
    var p = {
      'url' : window.location.href,
      'via' : 'pajaropolitico',
      'text' : '#JusticiaCotidiana: ' + this.props.p.title
    };
    var url = u + '?' + httpBuildQuery(p);
    var twurl = url;

    /* Facebook */
    var u = 'https://www.facebook.com/sharer/sharer.php';
    var p = {
      'u' : window.location.href,
    };
    var url = u + '?' + httpBuildQuery(p);
    var fburl = url;

    /* WhatsApp */
    var u = 'https://api.whatsapp.com/send';
    var p = {
      'text' : '#JusticiaCotidiana: ' + this.props.p.title + ' ' + window.location.href,
    };
    var url = u + '?' + httpBuildQuery(p);
    var waurl = url;

    /* Mail */
    var u = 'mailto:';
    var p = {
      'body' : window.location.href,
      'subject' : '#JusticiaCotidiana: ' + this.props.p.title
    };
    var url = u + '?' + httpBuildQuery(p);
    var mailurl = url;


    var shs = [
      {
        url: twurl,
        name: 'Twitter',
        icon: 'twitter'
      },
      {
        url: fburl,
        name: 'Facebook',
        icon: 'facebook'
      },
      {
        url: waurl,
        name: 'WhatsApp',
        icon: 'whatsapp'
      },
      {
        url: mailurl,
        name: 'Mail',
        icon: 'mail'
      },
    ];


    return(
      <div className="single_sharers">
        <div className="single_sharers_td single_sharers_td_label">Comparte</div>
        <div className="single_sharers_td single_sharers_td_content">
          {
            shs.map(function(sh){
              return(
                <div className="ssh_td">
                  <a href={sh.url} target="_blank" title={"Comparte en " + sh.title} alt={"Comparte en " + sh.title}>
                    <div className={"ssh_td_icon socicon-" + sh.icon}>
                    </div>
                  </a>
                </div>
              )

            })
          }
        </div>
      </div>
    )
  }
}
